<template>
    <div
        v-if="loaded && session"
        class="game-responsive responsive_10x16">
        <flg-frame :session="loaded ? session : null" />
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

import FlgFrame from '../../../common/flg/flg-frame.vue';

export default {
    name: 'game-flg',
    components: { FlgFrame },
    props: {
        gameId: {
            type: String,
            required: true
        },
        backUrl: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            loaded: false,
            isMobile: isMobile.phone || isMobile.tablet
        };
    },
    computed: {
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        lang() {
            return Vue.state.lang.currentLang;
        },
        session() {
            return Vue.state.flg.session.get();
        }
    },
    watch: {
        async $route() {
            await this.load();
        }
    },
    async created() {
        await Vue.state.player.ensure();
        await this.load();
    },
    methods: {
        async load() {
            this.loaded = false;

            if (this.isLoggedIn) {
                await Vue.state.flg.session.open(this.gameId, this.lang, this.isMobile, this.backUrl);
            } else {
                await Vue.state.flg.session.openDemo(this.gameId, this.lang, this.isMobile, this.backUrl);
            }

            if (this.isMobile) window.location.replace(this.session.gameUrl);

            this.loaded = true;
        }
    },
    beforeDestroy() {
        this.loaded = false;
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/game/game-flg.vue